import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["defs",{"key":"svg-defs"}],["g",{"fill":"currentColor","mask":"url(#hardhat-mono_svg__a)","key":"svg-g"}]]);